import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserAdapter, USER_LOADER } from './user.service';

@NgModule({
  imports: [CommonModule],
})
export class UserModule {}
